// Props partagées (ReactShell) depuis n'importe quel composant.
import { usePage } from '@inertiajs/react'
import type { SharedProps } from '@/types/shared'

export function useShared(): SharedProps {
  return usePage().props as unknown as SharedProps
}

/**
 * Équivalent de preserve_webview_in_link / preserve_webview_param côté
 * serveur : en mode app, ajoute webview=true au lien (avant le fragment).
 */
export function useWebviewHref(): (path: string) => string {
  const { webview } = useShared()
  return (path: string) => {
    if (!webview || path.includes('webview=true')) return path
    const [base, fragment] = path.split('#', 2)
    const withParam = base + (base.includes('?') ? '&' : '?') + 'webview=true'
    return fragment !== undefined ? `${withParam}#${fragment}` : withParam
  }
}
